import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AmazonService } from "../../../services/amazon.service";
import { ModalDirective } from "ngx-bootstrap";
import { BlurUtil } from "../../../common/utils/blurUtil";
import *  as hellosign from "hellosign-embedded";
import { SellerStatus } from "../../../objects/amazon/seller";


@Component({
    selector: 'amazon-sign-form-modal',
    templateUrl: 'amazon-sign-form-modal.component.html',
    moduleId: module.id.toString()
})
export class AmazonSignFormComponent implements OnInit {
    constructor(private router: Router, private amazonService: AmazonService) {
    }

    @Input()
    public idToBlur: string;

    @ViewChild('signModal')
    public signModal: ModalDirective;

    @ViewChild('signModalRef')
    public signModalRef: ElementRef;

    @Output()
    public signEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();


    public show() {
        this.signModal.show();
        BlurUtil.blurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
    }

    public onModalHidden(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public emitEvent(){
        this.signEventEmitter.emit(true);
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public async goToSign(): Promise<void> {
        this.amazonService.getHelloSignUrl(this.amazonService.seller).then((resp: any) => {
                if (!resp)
                    return;

                let signURL = resp.Data.signUrl.toString();
                let clientId = resp.Data.clientId.toString();
                this.signModal.hide();

                this.goToHelloSign(signURL, clientId).then((r: any) => {
                    this.amazonService.setCurrentSeller(this.amazonService.seller).then(resp => {
                        BlurUtil.unBlurMenu(this.idToBlur);
                        this.signEventEmitter.emit(true);
                    });
                });
            }
        )
    }

    public goToHelloSign(url: string, clientId: string) {

        BlurUtil.blurMenu(this.idToBlur);

        let self = this;

        return new Promise(function (resolve, reject) {
            (<any>hellosign).init(clientId);

            (<any>hellosign).open({
                url: url,
                allowCancel: true,
                skipDomainVerification: false,
                uxVersion: 2,
                height: 480,
                debug: false,
                messageListener: function (eventData: any) {
                    if (eventData.event == (<any>hellosign).EVENT_SIGNED) {
                        self.amazonService.seller.BnNumberStatus = SellerStatus.Done;
                        self.amazonService.seller.PoaNumber = SellerStatus.Done;
                    }

                    resolve(eventData);
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/amazon/sign/amazon-sign-form-modal.component.ts